import makeStyles from '@mui/styles/makeStyles';
import colors from 'global/styles/colors';
import { get } from '../../lib/lodash';

export const COLORS = {
    darkGrey: '#5F5F5F',
    bgPrimary: 'rgba(0,0,0,0.8)',
    bgPrimaryActive: 'rgba(0,0,0,0.9)',
    bgSecondary: '#5F5F5F',
    accentPrimary: 'red',
    accentPrimaryActive: 'white',
    iconsPrimary: 'black',
    iconsSecondary: 'white',
    header: 'rgba(0,0,0,0.6)',
    footer: 'rgba(0,0,0,0.6)',
    black: '#000000',
    white: '#ffffff',
    disabledText: 'rgba(255,255,255,0.5)',
    loader: 'rgba(0,0,0,0.4)',
    transparent: 'transparent',
    editBar: 'rgba(0,0,0,0.3)',
}

export default makeStyles((theme) => ({
    '@global': {
        '& body.Menu-open': {
            overflow: 'hidden !important',
        },

        '& #SfxPopper': {
            position: 'fixed',
            zIndex: 1300,
            
            '& .SfxMenu-root, & .SfxMenu-root > div': {
                backgroundColor: COLORS.bgPrimary,
            },

            '& .SfxMenuItem-root': {
                backgroundColor: 'transparent',

                '&:hover': {
                    backgroundColor: COLORS.darkGrey
                }
            },
        },

        '& .FIE_editor-content': {
            '& .SfxSelect-root, .SfxInput-fieldWrapper input': {
                color: COLORS.black
            },

            '& .FIE_tool-options-wrapper': {
                '& [title^="Shadow"]': {
                    display: 'none',
                }
            }
        },

        '& .FIE_canvas-container': {
            padding: `0px !important`,
        },

        '& .FIE_canvas-node': {
            backgroundColor: `${COLORS.transparent} !important`,
        },

        '& .FIE_warmth-tool-button': {
            display: 'none!important'
        },

        '& .FIE_topbar-history-buttons': {
            '& .FIE_topbar-reset-button': {
                display: 'none'
            }
        },

        '& .FIE_tools-item-wrapper label': {
            color: `${COLORS.white}!important`,
        },

        '& .FIE_image-tool-add-option-button': {
            borderColor: `${COLORS.black}!important`,

            '& .SfxButton-Label': {
                color: `${COLORS.black}!important`,
            },

            '&:hover': {
                backgroundColor: `${COLORS.black}!important`,

                '& .SfxButton-Label': {
                    color: `${COLORS.white}!important`,
                },
            }
        },

        '& .FIE_topbar': {
            flexDirection: 'row-reverse',
            padding: '8px !important'
        },

        '& .FIE_topbar-save-wrapper': {
            '& .FIE_topbar-save-button': {
                backgroundColor: COLORS.iconsPrimary,

                '&:hover': {
                    backgroundColor: COLORS.white,

                    '& span': {
                        color: COLORS.black
                    }
                }
            }
        }


    },

    mediaDisplay: {
        '&.printView': {
            '& .caption p': {
                fontSize: '18px !important',
                fontWeight: 'bold',
            }
        },

        '& .caption': {
            color: theme.palette.grey['500'],
        },

        '& .selectIcon': {
            position: 'absolute',
            top: 0,
            left: 0,

            '&.selected svg': {
                backgroundColor: 'white',
            }
        },

        '& .smallMediaContainer': {
            position: 'relative',
            width: '100%',
            height: '100%',

            '& .playIcon': {
                position: 'absolute',
                top: `calc(50% - ${theme.spacing(2)})`,
                left: `calc(50% - ${theme.spacing(2)})`,
                color: COLORS.white,
                fontSize: theme.spacing(4),
            }
        }
    },

    editMediaContainer: {
        '& .loadingwindow': {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            backgroundColor: COLORS.loader,
        },

        '& .MuiToggleButtonGroup-root': {
            '& button': {
                backgroundColor: COLORS.bgSecondary,

                '&.Mui-selected': {
                    backgroundColor: COLORS.white,

                    '& .material-icons': {
                        color: COLORS.black
                    }
                }
            }
        },

        '& .material-icons': {
            color: 'white'
        },

        '& .MuiPaper-root': {
            backgroundColor: COLORS.bgSecondary,
            color: 'white'
        },

        '& .MuiDialogHeader-root': {
            width: '100%',
            height: theme.spacing(8),
            backgroundColor: COLORS.header,
            display: 'flex',
            flexDirection: 'row',

            '& .toolbar': {
                marginLeft: 'auto',
                flexDirection: 'row',
                display: 'flex',
                alignItems: 'center',

                '& .tab': {
                    height: theme.spacing(8),
                    padding: '0 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',

                    '&.selected': {
                        backgroundColor: COLORS.bgSecondary
                    }
                },
            }
        },

        '& .MuiDialogContent-root': {
            padding: 0,
            position: 'relative',

            '& .ekTTdm': {
                color: 'white'
            },

            '& .fOCVxk': {
                backgroundColor: COLORS.bgSecondary
            },

            '& .FIE_tab:hover': {
                '& svg, label': {
                    color: COLORS.iconsSecondary
                }
            },

            '& .FIE_carousel-item > div': {
                borderRadius: 4,

                '&:hover svg': {
                    color: 'white',
                }
            },

            '& .imagecontainer': {
                position: 'relative',
                width: p => p.isMobile ? '100%' : '80%',
                height: 'calc(100% - 32px)',
                padding: p => p.isMobile ? 0 : '16px',
                overflow: 'hidden',

                '& img': {
                    objectFit: 'contain !important',
                    cursor: p => p.zoom > 1 ? 'move' : 'default',
                },

                '&.noTab': {
                    width: '100%',
                },
            },

            '& .dirButtons': {
                '& .dir': {
                    position: 'fixed',
                    height: 90,
                    width: 35,
                    top: '47%',
                    backgroundColor: COLORS.header,
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',

                    '&.prev': {
                        left: 0,

                        '& .material-icons': {
                            marginLeft: 5
                        }
                    },
                    '&.next': {
                        right: p => p.opt && p.opt != 'edit' ? 'calc(20% + 20px)' : 0,
                    }
                }
            },

            '& .sidebar': {
                height: 'calc(100% - 32px)',
                backgroundColor: p => p.isMobile ? COLORS.bgPrimary : COLORS.header,
                width: p => p.isMobile ? 'calc(100% - 32px)' : '20%',
                padding: theme.spacing(2),
                overflow: 'auto',
                position: p => p.isMobile ? 'absolute' : 'relative',

                '& .spaceVert': {
                    margin: `${theme.spacing(3)} 0`
                },

                '&.more button': {
                    color: COLORS.white,
                },

                '& .cbrow': {
                    cursor: 'pointer',
                }
            },

            '& .MuiCheckbox-root': {
                '& svg': {
                    color: COLORS.white,
                }
            },

            '& .MuiSelect-select': {
                backgroundColor: COLORS.bgSecondary,
                color: COLORS.white,
            }
        },

        '& .MuiDialogActions-root': {
            backgroundColor: COLORS.footer,

            '& .link': {
                color: colors.blue,
                fontWeight: 'bold',
                cursor: 'pointer',
                padding: `${theme.spacing(1)} 0`,
                fontSize: 14,

                '&.more': {

                }
            },

            '& .footerContainer': {
                flexDirection: p => p.showMore || p.hideCap ? 'column' : 'row',
                height: p => p.showMore ? 'auto' : theme.spacing(8),
            },

            '& .info': {
                width: p => p.showMore || p.hideCap ? '100%' : '25%',
                display: p => !p.showMore && (p.isMobile && get(p, 'values.custom_properties.caption')) ? 'none' : 'flex',

                '& svg': {
                    fontSize: '2rem'
                },

                '&.right': {
                    [theme.breakpoints.down('lg')]: {
                        display: 'none',
                    },
                },
            },

            '& .infotext': {
                marginLeft: theme.spacing(1),
                overflow: 'hidden',

                '& p': {
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }

            },

            '& .caption': {
                width: p => p.showMore ? '100%' : 'auto',
                flexDirection: p => p.showMmore ? 'row' : 'column',
                display: 'flex',
                flexGrow: 1,
                alignItems: 'center',
                justifyContent: 'center',
                maxHeight: '100%',

                '& .descriptionText': {
                    boxSizing: 'border-box',
                    width: '100%',
                    padding: `${theme.spacing(1)} 14px`,

                    '& p': {
                        margin: 0,
                    }
                }
            },

            '& .MuiOutlinedInput-root': {
                backgroundColor: COLORS.bgSecondary,
                color: COLORS.white,

                '&.Mui-disabled': {
                    backgroundColor: COLORS.transparent,
                    WebkitTextFillColor: COLORS.disabledText,
                    
                    '& fieldset': {
                        border: 'none',
                    }
                },

                '& .Mui-disabled': {
                    WebkitTextFillColor: COLORS.disabledText
                }
            }
        }
    },

    imageCaptions: {
        
    }
}));
